// 应用全局配置
module.exports = {
  baseUrl: 'https://bosssunwen.store/prod-api',
  // baseUrl: 'http://127.0.0.1:9999',
  // baseUrl: 'http://192.168.32.99:9999',
  // 应用信息
  appInfo: {
    // 应用名称
    name: "ruoyi-app",
    // 应用版本
    version: "1.1.0",
    // 应用logo
    logo: "/static/logo.png",
    // 官方网站
    site_url: "http://ruoyi.vip",
    // 政策协议
    agreements: [{
        title: "隐私政策",
        url: "https://ruoyi.vip/protocol.html"
      },
      {
        title: "用户服务协议",
        url: "https://ruoyi.vip/protocol.html"
      }
    ]
  }
}
